import { applyMiddleware, compose, createStore } from 'redux';
import { createLogger } from 'redux-logger';
import reducers from './reducers';
import thunkMiddleware from 'redux-thunk';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const loggerMiddleware = createLogger();

export const store = ((state: Object) =>
  createStore(reducers, state, composeEnhancers(applyMiddleware(thunkMiddleware, loggerMiddleware))))();